export const trash = () => (
  <path
    d="M3 6h2m0 0h16M5 6v14a2 2 0 002 2h10a2 2 0 002-2V6H5zm3 0V4a2 2 0 012-2h4a2 2 0 012 2v2m-6 5v6m4-6v6"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
